import React, { useCallback, useEffect, useState } from 'react';
import api from '../../api/axios';
import './LeadMeetingStatus.css';

const STATUS_LABELS = {
  meeting_booked: 'Afspraak geboekt',
  meeting_rescheduled: 'Afspraak verplaatst',
  meeting_cancelled: 'Afspraak geannuleerd',
  meeting_completed: 'Afspraak afgerond',
  meeting_no_show: 'Niet verschenen',
};
const MATCH_LABELS = {
  tracking_token: 'Persoonlijke boekingslink',
  email: 'E-mailadres',
  unique_name: 'Unieke naam',
  manual_review: 'Handmatig gekoppeld',
};

function LeadMeetingStatus({ campaignId, leadId }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    try {
      const response = await api.get(`/agent/campaigns/${campaignId}/leads/${leadId}/meeting-status`);
      setData(response.data);
      setError('');
    } catch (requestError) {
      setError(requestError.response?.data?.message || requestError.response?.data?.error || requestError.message);
    }
  }, [campaignId, leadId]);

  useEffect(() => { load(); }, [load]);

  if (error) return <section className="lead-meeting-card"><h2>Afspraakstatus</h2><p className="lead-meeting-error">{error}</p></section>;
  if (!data) return <section className="lead-meeting-card"><h2>Afspraakstatus</h2><p>Laden…</p></section>;

  const latest = data.latest;
  return <section className="lead-meeting-card">
    <div className="lead-meeting-header">
      <div><h2>Afspraakstatus</h2><p>Bookingevents uit {data.provider === 'none' ? 'de ingestelde afspraaktool' : data.provider}.</p></div>
      <button type="button" onClick={load}>Vernieuwen</button>
    </div>
    {!data.configured && <div className="lead-meeting-empty">Voor deze campagne is geen afspraaktool actief.</div>}
    {data.configured && !latest && <div className="lead-meeting-empty">Nog geen afspraak voor deze lead geregistreerd.</div>}
    {latest && <>
      <div className={`lead-meeting-status ${latest.type}`}><strong>{STATUS_LABELS[latest.type] || latest.type}</strong><span>{latest.startTime ? new Date(latest.startTime).toLocaleString() : new Date(latest.occurredAt).toLocaleString()}</span></div>
      <dl className="lead-meeting-details">
        <div><dt>Provider</dt><dd>{latest.source || data.provider}</dd></div>
        <div><dt>Match</dt><dd>{MATCH_LABELS[latest.matchMethod] || latest.matchMethod || 'Onbekend'}{latest.matchConfidence != null ? ` · ${Math.round(latest.matchConfidence * 100)}%` : ''}</dd></div>
        <div><dt>Invitee</dt><dd>{latest.inviteeName || 'Onbekend'}{latest.inviteeEmail ? ` · ${latest.inviteeEmail}` : ''}</dd></div>
        <div><dt>Campagnedoel</dt><dd>{data.outcome?.status === 'completed' ? `Voltooid${data.outcome.completedAt ? ` op ${new Date(data.outcome.completedAt).toLocaleString()}` : ''}` : 'Nog niet voltooid'}</dd></div>
      </dl>
      <div className="lead-meeting-links">
        {latest.meetingUrl && <a href={latest.meetingUrl} target="_blank" rel="noreferrer">Open meeting</a>}
        {latest.rescheduleUrl && <a href={latest.rescheduleUrl} target="_blank" rel="noreferrer">Afspraak verplaatsen</a>}
        {latest.cancelUrl && <a href={latest.cancelUrl} target="_blank" rel="noreferrer">Afspraak annuleren</a>}
      </div>
    </>}
    {data.openReviews > 0 && <p className="lead-meeting-review">{data.openReviews} bookingreview(s) kunnen mogelijk bij deze lead horen.</p>}
  </section>;
}

export default LeadMeetingStatus;
